
import React from "react";

/**
 * IntersectionIcon (AND) - Shows two overlapping circles with only the middle section highlighted
 */
export const IntersectionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg 
      width="22" 
      height="15" 
      viewBox="0 0 22 15" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ overflow: "visible" }}
      {...props}
    >
      {/* Left circle with outline only */}
      <circle 
        cx="7" 
        cy="7.5" 
        r="7" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        fill="none" 
      />
      
      {/* Right circle with outline only */}
      <circle 
        cx="14" 
        cy="7.5" 
        r="7" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        fill="none" 
      />
      
      {/* Intersection area (filled) */}
      <path 
        d="M10.5 1.5a7 7 0 0 0 0 12 7 7 0 0 0 0-12z" 
        fill="currentColor" 
      />
    </svg>
  );
};

/**
 * UnionIcon (OR) - Shows two overlapping circles with both circles highlighted
 */
export const UnionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg 
      width="22" 
      height="15" 
      viewBox="0 0 22 15" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ overflow: "visible" }}
      {...props}
    >
      {/* Left circle filled */}
      <circle
        cx="7"
        cy="7.5"
        r="7"
        fill="currentColor"
        fillOpacity="0.7"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      
      {/* Right circle filled */}
      <circle
        cx="14"
        cy="7.5"
        r="7"
        fill="currentColor"
        fillOpacity="0.7"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};
